import { Component } from '@angular/core';

import { HelpWidgetService } from 'src/app/app-common/services/help-widget.service';

@Component({
  selector: 'purchase-footer',
  templateUrl: './purchase-footer.component.html',
  styleUrls: ['./purchase-footer.component.scss'],
  standalone: false,
})
export class PurchaseFooterComponent {
  constructor(public helpWidgetService: HelpWidgetService) {}
}
